/** @type {import("../../../../shared/ui/data-table/model/data-table-contract").UnifiedTableRecord[]} */
export const medications = [
  {
    patientId: "10",
    module: "medications",
    pageTitle: "Medications",

    subnav: [
      { sectionId: "medications", label: "Medications" },
      {
        sectionId: "administered-medications",
        label: "Administered Medications",
      },
      { sectionId: "previous-medication", label: "Previous Medication" },
    ],

    sections: [
      {
        id: "medications",
        title: "Medications",
        tables: [
          {
            id: "medications-table",
            columns: [
              { key: "medication", header: "Medication", sortable: true },
              { key: "dose", header: "Dose" },
              { key: "unit", header: "Unit" },
              { key: "route", header: "Route" },
              { key: "unitMedicationType", header: "Unit" },
              { key: "frequency", header: "Frequency" },
              { key: "medDays", header: "Med Days" },
              { key: "start", header: "Start" },
              { key: "refill", header: "Refill" },
            ],
            rows: [
              {
                medication: "Cyclobenzaprine HCl 10 MG Oral Tablet",
                dose: "10",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "3 times a day",
                medDays: "0",
                start: "08/31/2017",
                refill: "None",
              },
              {
                medication: "Advil 200 MG Oral Capsule",
                dose: "200",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Capsule",
                frequency: "3 times a day",
                medDays: "0",
                start: "08/31/2017",
                refill: "None",
              },
              {
                medication: "Atorvastatin Calcium 20 MG Oral Tablet",
                dose: "20",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "-",
                frequency: "daily",
                medDays: "0",
                start: "08/31/2017",
                refill: "None",
              },
              {
                medication: "Lisinopril 10 MG Oral Tablet",
                dose: "10",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "daily",
                medDays: "30",
                start: "09/12/2017",
                refill: "2",
              },
              {
                medication: "Metformin HCl 500 MG Oral Tablet",
                dose: "500",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "2 times a day",
                medDays: "30",
                start: "10/01/2017",
                refill: "3",
              },
              {
                medication: "Omeprazole 20 MG Delayed Release Capsule",
                dose: "20",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Capsule",
                frequency: "daily before breakfast",
                medDays: "14",
                start: "10/15/2017",
                refill: "None",
              },
              {
                medication: "Albuterol 90 MCG Inhaler",
                dose: "2",
                unit: "Puff",
                route: "Inhalation",
                unitMedicationType: "Inhaler",
                frequency: "every 6 hours as needed",
                medDays: "30",
                start: "11/02/2017",
                refill: "1",
              },
              {
                medication: "Gabapentin 300 MG Oral Capsule",
                dose: "300",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Capsule",
                frequency: "at bedtime",
                medDays: "30",
                start: "11/18/2017",
                refill: "1",
              },
              {
                medication: "Acetaminophen 500 MG Oral Tablet",
                dose: "500",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "every 8 hours as needed",
                medDays: "10",
                start: "12/01/2017",
                refill: "None",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: [
                "medication",
                "dose",
                "unit",
                "route",
                "unitMedicationType",
                "frequency",
                "medDays",
                "start",
                "refill",
              ],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=1NH3GaOQb9TWAnONq5IXfH-f-uNEGPcA1",
                pdf: "https://drive.google.com/uc?export=download&id=1j0U3_OwWGtV9UExR26C8v7PrSxLHFx15",
                xls: "https://docs.google.com/spreadsheets/d/1EtAwFhQpNEYi59SfCAONMdGCNgHKUWrD/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },

      // ✅ Allergy History (1 row)
      {
        id: "administered-medications",
        title: "Administered Medications",
        tables: [],
      },

      // ✅ Past Surgical History (4 rows)
      {
        id: "previous-medication",
        title: "Previous Medication",
        tables: [],
      },
    ],
  },

  {
    patientId: "11",
    module: "medications",
    pageTitle: "Medications",

    subnav: [
      { sectionId: "medications", label: "Medications" },
      {
        sectionId: "administered-medications",
        label: "Administered Medications",
      },
      { sectionId: "previous-medication", label: "Previous Medication" },
    ],

    sections: [
      {
        id: "medications",
        title: "Medications",
        tables: [
          {
            id: "medications-table",
            columns: [
              { key: "medication", header: "Medication", sortable: true },
              { key: "dose", header: "Dose" },
              { key: "unit", header: "Unit" },
              { key: "route", header: "Route" },
              { key: "unitMedicationType", header: "Unit" },
              { key: "frequency", header: "Frequency" },
              { key: "medDays", header: "Med Days" },
              { key: "start", header: "Start" },
              { key: "refill", header: "Refill" },
            ],
            rows: [
              {
                medication: "Cyclobenzaprine HCl 10 MG Oral Tablet",
                dose: "10",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "3 times a day",
                medDays: "0",
                start: "08/31/2017",
                refill: "None",
              },
              {
                medication: "Advil 200 MG Oral Capsule",
                dose: "200",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Capsule",
                frequency: "3 times a day",
                medDays: "0",
                start: "08/31/2017",
                refill: "None",
              },
              {
                medication: "Atorvastatin Calcium 20 MG Oral Tablet",
                dose: "20",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "-",
                frequency: "daily",
                medDays: "0",
                start: "08/31/2017",
                refill: "None",
              },
              {
                medication: "Lisinopril 10 MG Oral Tablet",
                dose: "10",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "daily",
                medDays: "30",
                start: "09/12/2017",
                refill: "2",
              },
              {
                medication: "Metformin HCl 500 MG Oral Tablet",
                dose: "500",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "2 times a day",
                medDays: "30",
                start: "10/01/2017",
                refill: "3",
              },
              {
                medication: "Omeprazole 20 MG Delayed Release Capsule",
                dose: "20",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Capsule",
                frequency: "daily before breakfast",
                medDays: "14",
                start: "10/15/2017",
                refill: "None",
              },
              {
                medication: "Albuterol 90 MCG Inhaler",
                dose: "2",
                unit: "Puff",
                route: "Inhalation",
                unitMedicationType: "Inhaler",
                frequency: "every 6 hours as needed",
                medDays: "30",
                start: "11/02/2017",
                refill: "1",
              },
              {
                medication: "Gabapentin 300 MG Oral Capsule",
                dose: "300",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Capsule",
                frequency: "at bedtime",
                medDays: "30",
                start: "11/18/2017",
                refill: "1",
              },
              {
                medication: "Acetaminophen 500 MG Oral Tablet",
                dose: "500",
                unit: "MG",
                route: "Oral",
                unitMedicationType: "Tablet",
                frequency: "every 8 hours as needed",
                medDays: "10",
                start: "12/01/2017",
                refill: "None",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: [
                "medication",
                "dose",
                "unit",
                "route",
                "unitMedicationType",
                "frequency",
                "medDays",
                "start",
                "refill",
              ],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=1NH3GaOQb9TWAnONq5IXfH-f-uNEGPcA1",
                pdf: "https://drive.google.com/uc?export=download&id=1j0U3_OwWGtV9UExR26C8v7PrSxLHFx15",
                xls: "https://docs.google.com/spreadsheets/d/1EtAwFhQpNEYi59SfCAONMdGCNgHKUWrD/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },

      // ✅ Allergy History (1 row)
      {
        id: "administered-medications",
        title: "Administered Medications",
        tables: [],
      },

      // ✅ Past Surgical History (4 rows)
      {
        id: "previous-medication",
        title: "Previous Medication",
        tables: [],
      },
    ],
  },
];
